let lazyLoad=()=>{
    function lazyImage(){
        console.log(11)
        this.imageElements=[];
        this.setTime=0;
        this.cb=Object;
        this.loadErrImage='data:image/png;base64,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';
    }
    lazyImage.prototype.init=function(selector){
        console.log(selector)
        console.log(document.querySelectorAll(selector))
        this.imageElements=Array.prototype.slice.call(document.querySelectorAll(selector));
        this.start();
    }
    lazyImage.prototype.setImage=function(selector,cb){
        this.imageElements=Array.prototype.slice.call(document.querySelectorAll(selector));
        console.log(this.imageElements)
        this.cb=cb;
        this.setTime++;
        if(this.setTime>0){
            this.start();
        }
    }
    lazyImage.prototype.inViewShow=function(){
        let len = this.imageElements.length;
        for(let i =0;i<len;i++){
            let imageElement = this.imageElements[i];
            const rect = imageElement.getBoundingClientRect();
            if(rect.top<document.documentElement.clientHeight){
                let img=new Image();
                let imgKey=imageElement.dataset.key,
                    imgArray=imageElement.dataset.array;
            //    img.onload=()=>{
                   // imageElement.src=imageElement.dataset.src;
                    this.cb(imgArray,imgKey)

           /*     };
                img.onerror=()=>{
                    imageElement.src=this.loadErrImage;
                };
                img.src=imageElement.dataset.src;*/

                this.imageElements.splice(i,1)
                len--;
                i--;
                console.log('nice')
                if(this.imageElements.length===0){
                    window.removeEventListener('scroll',this._throttleFn)
                }
            }
        }
    }

    lazyImage.prototype.throttle=function(fn,delay=100,mustRun=200){
        let t_start=null,
            timer=null,
            context=this;
        return function(){
            let t_current = +(new Date());
            let args = Array.prototype.slice.call(arguments);
            clearTimeout(timer);
            if(!t_start){
                t_start = t_current;
            }
            if(t_current - t_start>mustRun){
                fn.apply(context,args);
                t_start = t_current;
            }else{
                timer = setTimeout(()=>{
                    fn.apply(context,args)
                },delay)
            }
        }
    }
    lazyImage.prototype.start=function(){
        //支持intersectionObservere的浏览器
        if("IntersectionObserver" in window){
            let lazyImageObserver = new IntersectionObserver((entries,observer)=>{
                entries.forEach((entry,index)=>{
                    //如果元素可见
                    if(entry.isIntersecting){
                        console.log('intersect加载完毕')
                        let lazyImage=entry.target;
                        let imgKey=lazyImage.dataset.key,
                            imgArray=lazyImage.dataset.array;
                         lazyImage.classList.add('beauty-loaded');
                         lazyImage.classList.remove("beauty-Load")
                         lazyImageObserver.unobserve(lazyImage)
                        //    img.onload=()=>{
                       // imageElement.src=imageElement.dataset.src;
                        this.cb(imgArray,imgKey)
                /*        img.onload=()=>{
                            lazyImage.src=lazyImage.dataset.src;
                            lazyImage.classList.add('lazy-loaded');
                            lazyImage.classList.remove("lazy-image")
                            lazyImageObserver.unobserve(lazyImage)
                        };
                        img.onerror=()=>{
                            lazyImage.src=this.loadErrImage;
                            lazyImage.classList.add('lazy-loaded');
                            lazyImage.classList.remove("lazy-image")
                            lazyImageObserver.unobserve(lazyImage)
                        };
                        img.src=lazyImage.dataset.src;*/

                    }
                })
            });
            this.imageElements.forEach((lazyImage)=>{
                lazyImageObserver.observe(lazyImage);
            })
        }else{
            this.inViewShow();
            this._throttleFn = this.throttle(this.inViewShow);
            window.addEventListener('scroll',this._throttleFn.bind(this))
        }
    }
    return new lazyImage();
}


export default lazyLoad